import React from "react";
import { useNavigate } from "react-router-dom";
import { newsImageUrl, timeAgo, CATEGORIES } from "../../api/news";
import { EyeIcon, HeartIcon, CommentIcon, PinIcon, CatIcon } from "./StatIcons";

/** Карточка новости в списке: обложка, рубрика, заголовок, описание, статистика. */
export default function NewsCard({ news }) {
  const navigate = useNavigate();
  const cat = CATEGORIES.find((c) => c.id === news.category);
  const cover = newsImageUrl(news.cover_image);

  return (
    <div className="nws-card" onClick={() => navigate(`/app/news/${news.id}`)}>
      {cover ? (
        <img className="nws-card-cover" src={cover} alt="" loading="lazy" />
      ) : (
        <div className="nws-card-nocover"><CatIcon id={news.category} size={40} /></div>
      )}
      <div className="nws-card-body">
        <div className="nws-card-meta">
          {news.is_pinned && <span className="nws-pin"><PinIcon /></span>}
          {cat && <span className="nws-badge"><CatIcon id={cat.id} /> {cat.label}</span>}
        </div>
        <h3 className="nws-card-title">{news.title}</h3>
        {news.summary && <p className="nws-card-summary">{news.summary}</p>}
        <div className="nws-card-date">{timeAgo(news.published_at)}</div>
        <div className="nws-card-stats">
          <span><EyeIcon /> {news.views_count}</span>
          <span><HeartIcon /> {news.likes_count}</span>
          <span><CommentIcon /> {news.comments_count}</span>
        </div>
      </div>
    </div>
  );
}
